import { useRef } from "react";
import { useUserContext } from "../../context/userContext";

import { useContext } from "react";
import { DarkModeContext } from "../DarkModeProvider";

import { Link } from "react-router-dom";

const ForgetPassword = () => {
  const { darkMode } = useContext(DarkModeContext);

  const emailRef = useRef();
  const psdRef = useRef();

  const { forgotPassword, signInUser } = useUserContext();

  const onSubmit = (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = psdRef.current.value;
    if (email && password) signInUser(email, password);
  };

  const forgotPasswordHandler = () => {
    const email = emailRef.current.value;

    if (email)
      forgotPassword(email).then(() => {
        emailRef.current.value = "";
    }).then(() => window.location = "/profile/email-sended")
  };

  return (
    <>
      <section className={darkMode ? "auth dark" : "auth light"}>
        <div className="container">
          <div className="auth__container">
            <h2 className={darkMode ? "dark-text" : "light-text"}>
              Obnovení hesla
            </h2>
            <form onSubmit={onSubmit} className="auth__content">
              <div className="auth__content--input">
                <label
                  className={
                    darkMode ? "dark-second-text" : "light-second-text"
                  }
                  htmlFor="email"
                >
                  Email
                </label>
                <input type="email" ref={emailRef} />
              </div>
              <button
                onClick={forgotPasswordHandler}
                className={
                  darkMode
                    ? "auth__content--button dark-button-text"
                    : "auth__content--button"
                }
                type="submit"
              >
                <span>Obnovit</span>
              </button>
            </form>
            <Link to="/profile" className={darkMode ? 'auth__login dark-text' : 'auth__login light-text'} >
               <span>Už jste si vzpomněli? </span>  <strong>Přihlaste se</strong>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;
